import { render, staticRenderFns } from "./LinkFile.vue?vue&type=template&id=740127b7"
import script from "./LinkFile.vue?vue&type=script&lang=js"
export * from "./LinkFile.vue?vue&type=script&lang=js"
import style0 from "./LinkFile.vue?vue&type=style&index=0&id=740127b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports